import TipBox from "../Common/TipBox";
import Panel from "../Common/Panel";
import store from "../Common/Store";
import RoomPlanHeader from "../Common/RoomPlanHeader";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

const roomShapes = [
  { id: 1, image: "img/Square.png", translationKey: "Rectangle form" },
  { id: 2, image: "img/L.png", translationKey: "L-shaped" },
  { id: 3, image: "img/T.png", translationKey: "T-shaped" },
];

function SelectPolygon() {
  const { t, i18n } = useTranslation();
  const [state, setState] = useState(1);

  useEffect(() => {
    store.empty();
    i18n.changeLanguage(localStorage.getItem("lang"));
  }, [i18n]);

  return (
    <main className="shape-select-page">
      <RoomPlanHeader
        title="Choose form"
        description="Select the option that best matches your room's overall layout."
      />

      <div
        className="shape-select-grid"
        role="radiogroup"
        aria-label={t("Choose form")}
      >
        {roomShapes.map((shape) => {
          const selected = state === shape.id;

          return (
            <button
              key={shape.id}
              type="button"
              role="radio"
              aria-checked={selected}
              className={`shape-select-card ${
                selected ? "shape-select-card--selected" : ""
              }`}
              onClick={() => setState(shape.id)}
            >
              <img
                className="shape-select-card__image"
                src={shape.image}
                alt=""
              />
              <span className="shape-select-card__label">
                {t(shape.translationKey)}
              </span>
              <span className="shape-select-card__check" aria-hidden="true">
                {selected ? "✓" : ""}
              </span>
            </button>
          );
        })}
      </div>

      <Panel page="1" />
      <TipBox
        tip="1"
        next={`/standartmode?fig_type=${state}`}
        prev="/mode"
      />
    </main>
  );
}

export default SelectPolygon;
